import {
    FLEPZRequest,
    RestDataResponseListNonPIIAccount,
    flepzPost,
} from '@cecm-microservices-sdk/core/services/identity/streaming/flepz';
import { getMicroservicesClient } from '@/services/microservices/client';
import type { MicroservicesCountryCode } from '@/services/microservices/usedCarEligibility';

export async function submitFlepzRequest(
    countryCode: MicroservicesCountryCode,
    payload: FLEPZRequest,
): Promise<RestDataResponseListNonPIIAccount> {
    const client = getMicroservicesClient(countryCode);

    if (!client.baseUrl) {
        throw new Error(
            `Missing microservices base URL for ${countryCode.toUpperCase()}. Check the runtime configuration for the active environment.`,
        );
    }

    return flepzPost(client, payload);
}
